import { h } from 'preact';
import dlv from 'dlv';

import style from './style';
import pageStyles from '../../pageStyles';

import SimpleGridCluster from '../../../clusters/simple-grid-cluster';
import CategoryCluster from '../../../clusters/category-cluster';
import RecommendedCluster from '../../../clusters/recommended-cluster';
import PromoCluster from '../../../clusters/promo-cluster';
import SupportCluster from '../../../clusters/support-cluster';
import { OccasionBanner } from '../../../pieces/occasion-banner';
import { TopBorder } from '../../../pieces/top-border';
import { SadlibAd } from '../../../pieces/sadlib-ad';
import { TaboolaJs } from '../../../pieces/taboola-js';
import { InsticatorJs } from '../../../pieces/insticator-js';
import { Autoplay } from '../../../pieces/autoplay';
import { Header, Footer, HeaderP25 } from '../../shared/desktop';
import { getCommonProps } from '../../../../lib/page';
import { getBucket } from '../../../../lib/abtest';
import { WeatherWidget } from '@cube/weather-widget';
import { DccWidget } from '@cube/dcc-widget-v2';
import { StocksWidget } from '@cube/finance-components';
import { Column, Row, Section, ContainerFluid } from '@cube/layout';
import Notifications from '@cube/notifications';
import { RenderOnVisible } from '@cube/blocks';
import TilesWidget from '../../../pieces/tiles-widget';
import cx from 'classnames';
import CardHeader from '../../../pieces/card-header';
import { default as SupportClusterP25 } from '../../../clusters/support-cluster-p23';
import SpeedClusterP25 from '../../../clusters/speed-cluster-p25';
import GameClusterP25 from '../../../clusters/game-cluster-p25';
import NewsClusterP25 from '../../../clusters/news-cluster-p25';
import HeroClusterP25 from '../../../clusters/hero-cluster';

const renderHeroSection = (isP25, pageConfig, props, width) => {
	const commonProps = getCommonProps(props);
	const heroTheme = pageConfig?.heroTheme || 'light';
	const tilesConfig = pageConfig?.tilesWidgetConfig;
	if (!isP25) {
		return (
			<Section
				rowClass={cx(pageStyles.heroTheme, pageStyles[heroTheme])}
				containerClass={pageStyles.defaultPageWidth}
			>
				<Notifications alertClass={style.notification} {...commonProps} />
				<Row class={style.heroRow}>
					<Column>
						{tilesConfig?.enableTilesWidget && tilesConfig?.isRightRail && (
							<CardHeader title="Top Stories" />
						)}
						<DccWidget
							variant={getBucket(pageConfig.dccVariantCookie)}
							{...dlv(pageConfig, 'clusters.dcc')}
							{...commonProps}
						/>
						<TaboolaJs
							{...dlv(pageConfig, 'taboola.subDcc')}
							class={style.subDccCluster}
							qeId="sc-home-subdcc"
						/>
					</Column>

					<Column class={pageStyles.largeFixedRightColumn}>
						{tilesConfig?.enableTilesWidget && tilesConfig?.isRightRail && (
							<div>
								<CardHeader
									title="Quick Links"
									customization={
										<span class={style.affiliateNote}>
											May contain affiliate links
										</span>
									}
									qeId="quick-links"
								/>
								<TilesWidget
									tilesWidgetConfig={tilesConfig}
									{...commonProps}
								/>
							</div>
						)}
						<Autoplay
							autoplay={dlv(pageConfig, 'autoplay')}
							taboola={dlv(pageConfig, 'taboola.autoplay')}
							id="sc_home_autoplay"
						/>
						<div class={style.defaultWidthAd}>
							<SadlibAd id="sc_home_hero_sidebar" type="desktopRail" />
						</div>
					</Column>
				</Row>
			</Section>
		);
	}

	return (
		<Section
			rowClass={cx(pageStyles.heroTheme, pageStyles[heroTheme])}
			containerClass={cx(pageStyles.defaultPageWidth, style.p25HeroPageWidth)}
		>
			<Notifications alertClass={style.notification} {...commonProps} />
			<HeroClusterP25
				qeId="sc-home-hero"
				// pageConfig={pageConfig}
				width={width}
				{...commonProps}
			/>
		</Section>
	);
};

export const Desktop = ({ pageConfig, width, ...props }) => {
	const isP25 = getBucket(pageConfig.p25VariantCookie) === 'p25Variant';
	return (
		<ContainerFluid class={pageStyles.fluidPageNoPadding}>
			{isP25 ? <HeaderP25 pageConfig={pageConfig} adId="sc_home_header_banner" {...props} /> :  <Header pageConfig={pageConfig} adId="sc_home_header_banner" {...props} />}
			<Section containerClass={pageStyles.defaultPageWidth}>
				{!pageConfig?.tilesWidgetConfig?.isRightRail && (
					<TilesWidget
						tilesWidgetConfig={pageConfig?.tilesWidgetConfig}
						{...getCommonProps(props)}
					/>
				)}
				<OccasionBanner />
				<SadlibAd id="sc_home_bodymasthead_banner" type="desktopBanner" />
				{dlv(pageConfig, 'clusters.promo.aboveDCC') && (
					<Row>
						<Column>
							<PromoCluster
								{...dlv(pageConfig, 'clusters.promo')}
								{...getCommonProps(props)}
							/>
						</Column>
					</Row>
				)}
			</Section>
			{renderHeroSection(isP25, pageConfig, props, width)}
			<Section containerClass={pageStyles.defaultPageWidth}>
				{dlv(pageConfig, 'clusters.promo.belowDCC') && (
					<Row>
						<Column class={style.verticalMargin}>
							<PromoCluster
								{...dlv(pageConfig, 'clusters.promo')}
								{...getCommonProps(props)}
							/>
						</Column>
					</Row>
				)}
				<Row>
					<Column>
						{dlv(pageConfig, 'clusters.support.mode') !== 'p25' && (
							<SupportCluster
								{...dlv(pageConfig, 'clusters.support')}
								qeId="sc-home-alerts"
								{...getCommonProps(props)}
							/>
						)}
					</Column>
				</Row>
			</Section>
			{dlv(pageConfig, 'taboola.mode') !== 'P25' && (
				<Section
					rowClass={style.recRow}
					containerClass={pageStyles.defaultPageWidth}
				>
					{pageConfig.useTaboolaFeatured ? (
						<TaboolaJs
							{...dlv(pageConfig, 'taboola.featured')}
							qeId="sc-home-taboolafeatured"
						/>
					) : (
						<RecommendedCluster
							{...dlv(pageConfig, 'clusters.recommended')}
							qeId="sc-home-recommended"
							{...getCommonProps(props)}
						/>
					)}
				</Section>
			)}

			{dlv(pageConfig, 'clusters.newsTabs') && (
				<Section containerClass={pageStyles.defaultPageWidth}>
					<NewsClusterP25 pageConfig={pageConfig} width={width} {...props} />
				</Section>
			)}

			{dlv(pageConfig, 'taboola.mode') === 'P25' && (
				<Section containerClass={pageStyles.defaultPageWidth}>
					<Row>
						<Column>
							<SadlibAd id="sc_home_news_banner" type="desktopBanner" />
						</Column>
					</Row>
					<TopBorder />
					<Row>
						<Column class={pageStyles.fixedLeftColumn}>
							<CardHeader
								qeId="sc-home-taboolafeatured"
								title="Spotlight For You"
							/>
							{pageConfig.useTaboolaFeatured ? (
								<TaboolaJs
									{...dlv(pageConfig, 'taboola.featured')}
									qeId="sc-home-taboolafeatured"
								/>
							) : (
								<RecommendedCluster
									{...dlv(pageConfig, 'clusters.recommended')}
									qeId="sc-home-recommended"
									{...getCommonProps(props)}
								/>
							)}
						</Column>
						<Column class={pageStyles.smallFixedRightColumn}>
							{dlv(pageConfig, 'clusters.insticator.id') ? (
								<InsticatorJs
									{...dlv(pageConfig, 'clusters.insticator')}
									requireComplete
								/>
							) : (
								<SimpleGridCluster
									{...dlv(pageConfig, 'clusters.latestTrailers')}
									qeId="sc-home-trailers"
									{...getCommonProps(props)}
								/>
							)}
							<SadlibAd id="sc_home_entertainment_sidebar" type="desktopRail" />
						</Column>
					</Row>
				</Section>
			)}

			{ dlv(pageConfig, 'clusters.gamesCluster') && (
				<Section containerClass={pageStyles.defaultPageWidth}>
					<TopBorder />
					<GameClusterP25
						qeId="sc-home-game"
						pageConfig={pageConfig}
						{...props}
					/>
				</Section>
			)}

			{ dlv(pageConfig, 'clusters.speed') && (
				<Section containerClass={pageStyles.defaultPageWidth}>
					<Row>
						<Column>
							<SadlibAd id="sc_home_stream2" type="desktopBanner" />
						</Column>
					</Row>
					<TopBorder />
					{dlv(pageConfig, 'clusters.support.mode') === 'p25' && (
						<SupportClusterP25
							{...dlv(pageConfig, 'clusters.support')}
							qeId="sc-home-alerts"
							{...getCommonProps(props)}
						/>
					)}
					<SpeedClusterP25
						pageConfig={pageConfig}
						width={width}
						qeId="sc-home-speed"
						{...getCommonProps(props)}
					/>
				</Section>
			)}

			{!dlv(pageConfig, 'clusters.newsTabs') && (
				<div>
					<Section containerClass={pageStyles.defaultPageWidth}>
						<Row>
							<SadlibAd id="sc_home_recommended_banner" type="desktopBanner" />
							<Column class={pageStyles.fixedLeftColumn}>
								<TopBorder />
								<CategoryCluster
									{...dlv(pageConfig, 'clusters.latestEntertainment')}
									qeId="sc-home-entertainment"
									{...getCommonProps(props)}
								/>
							</Column>
							<Column class={pageStyles.fixedRightColumn}>
								<TopBorder />
								{dlv(pageConfig, 'clusters.insticator.id') ? (
									<InsticatorJs
										{...dlv(pageConfig, 'clusters.insticator')}
										requireComplete
									/>
								) : (
									<SimpleGridCluster
										{...dlv(pageConfig, 'clusters.latestTrailers')}
										qeId="sc-home-trailers"
										{...getCommonProps(props)}
									/>
								)}
								<SadlibAd
									id="sc_home_entertainment_sidebar"
									type="desktopRail"
								/>
							</Column>
						</Row>
					</Section>
					<Section
						rowClass={style.recRow}
						containerClass={pageStyles.defaultPageWidth}
					>
						<TopBorder />
						<SimpleGridCluster
							{...dlv(pageConfig, 'clusters.latestHealth')}
							qeId="sc-home-latestHealth"
							{...getCommonProps(props)}
						/>
					</Section>
				</div>
			)}
			<Section containerClass={pageStyles.defaultPageWidth}>
				{!dlv(pageConfig, 'clusters.newsTabs') && (
					<div>
						<Row>
							<Column class={pageStyles.fixedLeftColumn}>
								<TopBorder />
								<CategoryCluster
									{...dlv(pageConfig, 'clusters.latestNews')}
									qeId="sc-home-news"
									{...getCommonProps(props)}
								/>
							</Column>
							<Column class={pageStyles.fixedRightColumn}>
								<TopBorder />
								<RenderOnVisible>
									<WeatherWidget {...getCommonProps(props)} />
								</RenderOnVisible>
								<TaboolaJs
									class={style.youMayAlsoLike}
									{...dlv(pageConfig, 'taboola.rightRailBelowWeather')}
									qeId="sc-home-youmayalsolike"
								/>
							</Column>
						</Row>
						<Row>
							<Column>
								<SadlibAd id="sc_home_news_banner" type="desktopBanner" />
							</Column>
						</Row>
						<Row>
							<Column class={pageStyles.fixedLeftColumn}>
								<TopBorder />
								<CategoryCluster
									{...dlv(pageConfig, 'clusters.latestSports')}
									qeId="sc-home-sports"
									{...getCommonProps(props)}
								/>
							</Column>
							<Column class={pageStyles.fixedRightColumn}>
								<TopBorder />
								<SimpleGridCluster
									{...dlv(pageConfig, 'clusters.sportsVideos')}
									qeId="sc-home-sportsvideos"
									{...getCommonProps(props)}
								/>
								<SadlibAd id="sc_home_sports_sidebar" type="desktopRail" />
							</Column>
						</Row>
						<Row>
							<Column class={pageStyles.fixedLeftColumn}>
								<TopBorder />
								<CategoryCluster
									{...dlv(pageConfig, 'clusters.latestBusiness')}
									qeId="sc-home-business"
									{...getCommonProps(props)}
								/>
							</Column>
							<Column class={pageStyles.fixedRightColumn}>
								<TopBorder />
								<RenderOnVisible>
									<StocksWidget {...getCommonProps(props)} />
								</RenderOnVisible>
								<SadlibAd id="sc_home_business_sidebar" type="desktopRail" />
							</Column>
						</Row>
					</div>
				)}
				<TopBorder />
				<TaboolaJs
					{...dlv(pageConfig, 'taboola.bottomPage')}
					qeId="sc-home-taboolabottompage"
				/>
			</Section>
			<SadlibAd id="adhesion" />
			<Footer pageConfig={pageConfig} {...getCommonProps(props)} />
		</ContainerFluid>
	);
};
